module.exports = __webpack_public_path__ + "img/songlei.f0e79503.jpg";